export default "__VITE_ASSET__Btsnxjvz__"